var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.7227C4.486 20.7227 0 16.2367 0 10.7227C0 5.20866 4.486 0.722656 10 0.722656C15.514 0.722656 20 5.20866 20 10.7227C20 16.2367 15.514 20.7227 10 20.7227ZM10 2.72266C5.589 2.72266 2 6.31166 2 10.7227C2 15.1337 5.589 18.7227 10 18.7227C14.411 18.7227 18 15.1337 18 10.7227C18 6.31166 14.411 2.72266 10 2.72266Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9991 5.06509L8.99865 5.0658L8.99936 9.7221L4.34235 9.7221L4.34165 11.7225L8.99865 11.7225V16.3795L10.9991 16.3788L10.9998 11.7225L15.6554 11.7225L15.6561 9.7221L10.9991 9.7221L10.9991 5.06509Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.6adba374d56ba24237f42edecd467a09.svg";
export { ForwardRef as ReactComponent };